// Data submit
// {
//   segment_id: 123,                // ID của segment được lấy trong buffer từ int32 thứ 7
//   server_at: 1706494993137,       // Thời gian segment này được push vào flv trên server
//   client_at: 1706494993137,       // Thời gian segment này được client lấy về
//   playing_at: 1706494993137,      // Thời gian segment này được play cho user xem
//   start_at: 123,                  // Segment này sẽ bắt đầu ở giây thứ 123
//   end_at: 123,                    // Segment này sẽ kết thúc ở giây thứ 123
//   size: 123123,                   // Kích thước của segment này
//   num_err: 1,                     // Số lỗi mà client dính phải
//   errs: ['Something went wrong!'] // Message các lỗi
//   pf: 1,                          // Nên tảng user đang sử dụng [web, ios,....]
//   nw: 1,                          // Network của user đang sử dụng [wifi...]
//   latest_segment: 1706494993137,  // Thời gian server của segment mới nhất
//   latency: 3,
// }

// Data segment
// {
//   segment_id: 123,
//   server_at: 1706494993137,
//   client_at: 1706494993137,
//   playing_at: 1706494993137,
//   start_at: 123,
//   end_at: 124,
//   size: 123123,
//   latency: 3,
// }

import EventEmitter from "events";
import md5 from "md5";
import { v4 as uuidv4 } from "uuid";

const API_URL = "https://dev-zls-open.zapps.me/api/v1";
const API_PATH = {
  LOG: `${API_URL}/log`,
};
const API_KEY = "c75c49b675f39cadc5e287cec3a28d7d3deb76e5bd5b739244e920b679f9";
const INTERVAL_TIME_LOG = 10 * 1000;
const SECRET_KEY = "97a724a1ac4baa52fc18";
const LOCAL_STORAGE_KEY = "zls_id";
const LOCAL_STORAGE_ERROR_KEY = "zls_err";
const VERION = "1.0.4";

const getPlatform = () => {
  if (window.navigator.userAgent.match(/webOS/i)) {
    return 5;
  }
  if (window.navigator.userAgent.match(/Android/i)) {
    return 6;
  }
  return 7;
};

const getNetworkType = () => {
  return 1;
};

const sortObjectKey = (objectKey) =>
  Object.keys(objectKey)
    .sort()
    .reduce((obj, key) => {
      obj[key] = objectKey[key];
      return obj;
    }, {});

const getSig = (time, params) => {
  let str = "";
  const sortParams = sortObjectKey(Object.assign({}, params, { ts: time }));
  for (const key in sortParams) {
    if (sortParams[key] !== undefined) {
      str += `${key}=${sortParams[key]}&`;
    }
  }
  str = str.replace(/\[\]/g, "").replace(/ /g, "");
  return md5(`${str}${SECRET_KEY}`);
};

const getIdBrowser = () => {
  // check in local storage
  const storageId = localStorage.getItem(LOCAL_STORAGE_KEY);
  if (storageId && storageId.length > 0) {
    return storageId;
  }
  const newId = uuidv4();
  localStorage.setItem(LOCAL_STORAGE_KEY, newId);
  return newId;
};

class ApiLog {
  constructor() {
    if (this.instance) {
      throw new Error("You can only create one instance!");
    }

    // pf & nw
    this._network = getNetworkType();
    this._platform = getPlatform();

    // segment
    this._mapFrames = []; // array list number

    this._first_seek = 0;
    this._browser_id = getIdBrowser();
    this._is_push_error = false;
    this._loaded_at = 0;
    this._buffering = 0;
    this._frame = 0;
    this._last_time = 0;
    //server
    this._ip = "";
    this._instance_id = 0;

    // events
    this._emitter = new EventEmitter();
    this._emitter.on("error", this.handleError.bind(this));

    // interval
    this._interval = setInterval(() => {
      this.send();
    }, INTERVAL_TIME_LOG);

    this.instance = this;
  }

  setErrorMessage(params) {
    if (!this._is_push_error) {
      return;
    }
    let newError = [...params];
    // check in local storage
    let local = localStorage.getItem(LOCAL_STORAGE_ERROR_KEY);
    if (!local) {
      local = "";
    }
    const error_local = local
      .split(",")
      .filter((item) => item && item.length > 0);
    if (error_local.length > 0) {
      newError = [...newError, ...error_local];
    }

    // push to list
    localStorage.setItem(LOCAL_STORAGE_ERROR_KEY, newError.join(","));
  }

  getErrorMessage() {
    // get in local storage
    const error_local = localStorage
      .getItem(LOCAL_STORAGE_ERROR_KEY)
      .split(",")
      .filter((item) => item && item.length > 0);
    // clear mem & local storage
    localStorage.setItem(LOCAL_STORAGE_ERROR_KEY, "");
    // return value
    return error_local;
  }

  handleError(error) {
    let msg = "";
    if (error.message) {
      msg = error.message;
    } else {
      msg = "Unknown";
    }
    this.setErrorMessage([msg]);
  }

  logError(param) {
    this._emitter.emit("error", param);
  }

  setPlayingAt(time) {
    if (!time) return;
    if (time > 0) {
      this._is_push_error = true;
    }
    this._playing_at = time;
    this._playing_time = new Date().getTime();
  }

  setFrame(frame) {
    if (!frame || !frame.dts) {
      return;
    }
    this._frame += 1;
    frame.id = this._frame;

    this._mapFrames.push(frame);
  }

  getSegment(segment_id) {
    if (
      segment_id === undefined ||
      `${segment_id}` === "0" ||
      segment_id === null
    ) {
      return null;
    }
    const segment = this._catchSegment.get(`${segment_id}`);
    if (!segment || segment.id === undefined) {
      return null;
    }
    return segment;
  }

  removeSegment(segment_id) {
    if (!segment_id) return;
    // this._catchSegment.delete(`${segment_id}`);
    for (let i = 0; i < this._mapFrames.length; i += 1) {
      const segId = this._mapFrames[i];
      if (segId < Number(segment_id)) {
        this._mapFrames.splice(i, 1);
        i -= 1;
      }
    }
  }

  getAndRemoveSegment(segment_id) {
    let result = null;
    const segment = this.getSegment(segment_id);
    if (!segment || !segment.id) {
      return result;
    }
    result = Object.assign({}, segment);
    this.removeSegment(segment_id);
    return result;
  }

  setError(msg) {
    if (msg) {
      this.setErrorMessage([msg]);
    }
  }

  setInstanceId(id) {
    if (id && id > 0 && this._instance_id === 0) {
      this._instance_id = id;
    }
  }

  setFirstSeek(time) {
    this._first_seek = time;
  }

  getData(frame) {
    if (!frame) {
      console.warn("__LOG: Null frame");
      return null;
    }

    return {
      uid: this._browser_id,
      ip: this._ip,
      instance: this._instance_id,
      first_seek: this._first_seek,
      server_at: frame.server_at,
      sid: frame.id,
      loaded_at: this._loaded_at / 1000,
      buffering: this._buffering,
    };
  }

  getOptions(data, controller) {
    const dataPost = {
      log: JSON.stringify(data),
      pf: getPlatform(),
    };
    const ts = new Date().getTime();
    const sig = getSig(ts, dataPost);
    const dataObject = Object.assign({}, dataPost, {
      ts: ts,
      sig: sig,
    });
    const body = [];
    for (const property in dataObject) {
      const encodedKey = property;
      const encodedValue = dataObject[property];
      body.push(encodedKey + "=" + encodedValue);
    }
    return {
      method: "POST",
      headers: {
        // "Access-Control-Allow-Origin": "*",
        "Api-Key": API_KEY,
        "Content-Type": "application/x-www-form-urlencoded",
        "Ext-Info": JSON.stringify({
          av: VERION,
          an: "production",
          pf: getPlatform(),
          nw: getNetworkType(),
        }),
      },
      body: body.join("&"),
      signal: controller?.signal,
    };
  }

  async sendLog(data) {
    const controller = new AbortController();

    const timer = setTimeout(() => controller.abort(), 300);

    fetch(API_PATH.LOG, this.getOptions(data, controller))
      .then(function (res) {
        clearTimeout(timer);
        if (!res.ok) {
          console.warn(res.status, res.statusText);
          return;
        }
      })
      .catch(function (errorMessage) {
        clearTimeout(timer);
        console.warn(errorMessage);
      });
  }

  async postData(frame) {
    const data = this.getData(frame);
    if (!data) {
      console.warn("__LOG: Data is Empty");
      return;
    }

    this._mapFrames.splice(0, frame.index);
    this.sendLog(data);
  }

  getCurrentFrame() {
    let time = this._mediaElement.currentTime ?? 0;
    // console.log(time - this._last_time);
    // if (this._last_time > 0 && time - this._last_time < 7) {
    //   return;
    // }
    this._last_time = time;
    if (time === -1 || time === undefined || this._mapFrames.length < 1) {
      return;
    }
    for (let i = 0; i < this._mapFrames.length; i++) {
      // console.log("item: ", item);
      const item = this._mapFrames[i];
      if (item.dts >= time * 1000) {
        return {
          ...item,
          index: i,
        };
      }
    }
  }

  async send() {
    // get current segment playing
    const frame = this.getCurrentFrame();

    if (!frame) {
      return;
    }

    this.postData(frame);
  }

  stopSendLog() {
    clearInterval(this._interval);
  }

  setIp(ip) {
    this._loaded_at = new Date().getTime();
    if (ip && ip.length > 0) {
      this._ip = ip;
      const data = {
        uid: this._browser_id,
        ip: this._ip,
        server_at: 0,
        sid: 0,
        buffering: 0,
        instance: "",
      };

      this.sendLog(data);
    } else {
      const data = {
        uid: this._browser_id,
        ip: "",
        server_at: 0,
        sid: 0,
        buffering: 0,
        instance: "",
      };

      this.sendLog(data);
      // this.stopSendLog();
    }
  }

  sendAbort() {
    const data = {
      uid: this._browser_id,
      ip: "",
      server_at: -1,
      sid: -1,
      buffering: 0,
      instance: "",
    };

    this.sendLog(data);
  }

  setCanPlay() {
    const frame = this.getCurrentFrame();
    this._loaded_at = new Date().getTime() - this._loaded_at;
    const data = this.getData(frame);
    this.sendLog(data);
  }

  attachMediaElement(mediaElement) {
    this._mediaElement = mediaElement;
  }

  onBuffering() {
    this._buffering += 1;
  }
}

export default new ApiLog();
